import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { topNavStyle } from "../components/nav/topNavStyle";
import { supabase } from "../supabase/supabase";
import BrandWordmark from "../components/BrandWordmark";

const inputStyle = {
  width: '100%',
  padding: '12px 16px',
  borderRadius: 12,
  border: '1.5px solid var(--color-border)',
  fontSize: 15,
  color: 'var(--color-text-strong)',
  outline: 'none',
  boxSizing: 'border-box',
  backgroundColor: 'var(--color-bg-page)',
};

const labelStyle = {
  display: 'block',
  fontSize: 13,
  fontWeight: 600,
  color: 'var(--color-text-muted)',
  marginBottom: 6,
};

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/reset-password`,
      });
    } catch (err) {
      // Always show success — don't reveal if email exists
    } finally {
      setLoading(false);
      setSuccess(true);
      setTimeout(() => navigate("/login"), 4000);
    }
  };

  return (
    <div className="theme-auto" style={{ minHeight: '100vh', backgroundColor: 'var(--color-bg-card)', display: 'flex', flexDirection: 'column' }}>

      {/* Nav */}
      <nav style={topNavStyle({ paddingX: 24, paddingY: 16 })}>
        <Link to="/"><BrandWordmark width="clamp(100px, 25vw, 160px)" /></Link>
        <Link to="/login" style={{ fontSize: 14, fontWeight: 600, color: 'var(--color-cta)', textDecoration: 'none' }}>
          Back to login
        </Link>
      </nav>

      {/* Content */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '40px 24px' }}>
        <div style={{ width: '100%', maxWidth: 400 }}>

          {!success ? (
            <>
              <h1 style={{ fontSize: 26, fontWeight: 900, color: 'var(--color-text-strong)', marginBottom: 8 }}>Reset your password</h1>
              <p style={{ fontSize: 15, color: 'var(--color-text-muted)', marginBottom: 32 }}>
                Enter your email and we'll send you a reset link.
              </p>

              <form onSubmit={handleResetPassword} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                <div>
                  <label style={labelStyle}>Email</label>
                  <input
                    type="email"
                    name="email"
                    autoComplete="username"
                    inputMode="email"
                    autoCapitalize="none"
                    autoCorrect="off"
                    spellCheck="false"
                    placeholder="your@email.com"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    required
                    style={inputStyle}
                  />
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  style={{
                    padding: '14px 0', borderRadius: 50, border: 'none',
                    cursor: loading ? 'not-allowed' : 'pointer',
                    backgroundColor: loading ? 'var(--color-cta-disabled)' : 'var(--color-cta)',
                    color: '#fff', fontWeight: 700, fontSize: 16, marginTop: 8,
                  }}
                >
                  {loading ? "Sending..." : "Send reset link"}
                </button>
              </form>

              <p style={{ fontSize: 14, color: 'var(--color-text-muted)', textAlign: 'center', marginTop: 24 }}>
                Remember your password?{' '}
                <Link to="/login" style={{ color: 'var(--color-cta)', fontWeight: 600, textDecoration: 'none' }}>Log in</Link>
              </p>
            </>
          ) : (
            <div style={{ textAlign: 'center' }}>
              <div style={{
                width: 56, height: 56, borderRadius: '50%', backgroundColor: 'var(--color-success-bg)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                margin: '0 auto 24px', fontSize: 24,
              }}>
                ✓
              </div>
              <h2 style={{ fontSize: 22, fontWeight: 900, color: 'var(--color-text-strong)', marginBottom: 8 }}>Check your email</h2>
              <p style={{ fontSize: 15, color: 'var(--color-text-muted)', marginBottom: 24 }}>
                If an account exists for <strong>{email}</strong>, a reset link has been sent. Check your inbox and spam folder.
              </p>
              <p style={{ fontSize: 13, color: 'var(--color-text-faint)' }}>Redirecting to login...</p>
            </div>
          )}

        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
